import { FetchPaymentProviders } from "@/services/DataService";
import {
  IPaymentProvider,
  IPaymentProviderBackend,
  IPaymentProviderParams,
} from "@/types/IPaymentProvider";
import authHelper from "@/helpers/authHelper";

export class APIPaymentProvidersData implements FetchPaymentProviders {
  async fetchData(params: IPaymentProviderParams): Promise<IPaymentProvider[]> {
    try {
      const response = await authHelper.getProviders();
      // Now, get the IPaymentProvidersBackend[] and convert it to IPaymentProvider[]
      return response.map(
        (provider: IPaymentProviderBackend): IPaymentProvider => {
          return {
            name: provider.name,
            logo: provider.logo_url,
            displayName: provider.display_name,
            toolTip: provider.tooltip,
            tooltipPrefix: provider.tooltip_prefix,
            tooltipSuffix: provider.tooltip_suffix,
            bottomMessage: provider.bottom_message,
            country: provider.country,
            order: provider.order,
            type: provider.type,
            showGrouped: provider.show_grouped,
            active: provider.active,
            enabled: provider.enabled,
            highlight: provider.highlight,
            fee: parseFloat(provider.fee),
            title1: provider.title1,
            title2: provider.title2,
            reason_text: provider.reason_text,
          } as IPaymentProvider;
        }
      );
    } catch (error: unknown) {
      console.error(`Error fetching payment providers: ${error}`);
      throw error;
    }
  }
}
